export default __webpack_public_path__ + "static/media/Snow.2ccf24fc.svg";